export function formatRupiah(value: number | string, withPrefix: boolean = true): string {
  const n = Number(value) || 0;
  const s = n.toLocaleString('id-ID');
  return withPrefix ? `Rp. ${s}` : s;
}

export default formatRupiah;
